<template>
  <div class="ui-kit-v2-stepper">
    <Button
      v-if="showNavButtons"
      class="ui-kit-v2-stepper__button"
      size="s"
      variant="primary"
      :disabled="previousStepIsDisabled"
      @click="previousStep"
    >
      Назад
    </Button>
    <StepperDisplay
      :current-step-idx="currentStepIdx"
      :steps="steps"
      :show-nav-buttons="showNavButtons"
    ></StepperDisplay>
    <div class="ui-kit-v2-stepper__button-container--xs">
      <Button
        v-if="showNavButtons"
        class="ui-kit-v2-stepper__button--xs"
        size="s"
        variant="primary"
        :disabled="previousStepIsDisabled"
        @click="previousStep"
      >
        Назад
      </Button>
      <Button
        v-if="showNavButtons"
        class="ui-kit-v2-stepper__button--xs"
        size="s"
        :disabled="nextStepIsDisabled"
        @click="nextStep"
      >
        Далее
      </Button>
    </div>
    <Button
      v-if="showNavButtons"
      class="ui-kit-v2-stepper__button"
      size="s"
      :disabled="nextStepIsDisabled"
      @click="nextStep"
    >
      Далее
    </Button>
  </div>
</template>

<script>
import StepperDisplay from './components/StepperDisplay';
import Button from '@/components/UiKit/v2/Button';

export default {
  name: 'Stepper',
  components: {
    StepperDisplay,
    Button
  },
  props: {
    /**
     * Текущий индекс шага
     */
    currentStepIdx: {
      type: Number,
      default: 0
    },
    /**
     * Список шагов
     */
    steps: {
      type: Array,
      default: () => {
        [];
      }
    },
    /**
     * Отображение кнопок
     */
    showNavButtons: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    previousStepIsDisabled() {
      return this.currentStepIdx === 0;
    },
    nextStepIsDisabled() {
      return this.currentStepIdx === this.steps.length - 1;
    }
  },
  methods: {
    goToStep(idx) {
      if (idx !== this.currentStepIdx) {
        this.$emit('goToStep', idx);
      }
    },
    previousStep() {
      const index = Math.max(0, this.currentStepIdx - 1);
      this.goToStep(index);
    },
    nextStep() {
      const index = Math.min(this.steps.length, this.currentStepIdx + 1);
      this.goToStep(index);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.ui-kit-v2-stepper {
  $screen-sm: 600px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @include media($screen-sm) {
    flex-direction: column;
  }

  &::v-deep button {
    min-width: 156px;
  }

  &__button-container--xs {
    display: none;
    align-items: center;
    justify-content: center;
    width: 100%;
    @include media($screen-sm) {
      display: flex;

      &::v-deep button {
        min-width: unset;
        flex-grow: 1;

        &:not(:last-child) {
          margin-right: 16px;
        }
      }
    }
  }

  &__button {
    display: block;

    @include media($screen-sm) {
      display: none;
    }
  }
}
</style>
